module.exports = __webpack_public_path__ + "img/online.d8e0d8a2.svg";